/**
 * render-monthly-report
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

export default (data, findStationName) => {
    return data.map(station => {
        const name = (findStationName(station.station_id).new_name)
            ? findStationName(station.station_id).new_name
            : findStationName(station.station_id).name;

        const fmt = new Intl.DateTimeFormat("en-GB", {
            month: "short",
            year: "numeric"
        });

        let stationHtml = [`<h3>${name}</h3>`];

        //noinspection Eslint
        for (let period in station.data) {
            //noinspection JSUnfilteredForInLoop
            let periodDesc = fmt.format(new Date(
                    period.substr(0, 4),
                    period.substr(4, 2) - 1, // Silly JS: Jan = 0
                    1
                ));
            stationHtml.push(`<h4>${periodDesc}</h4>`);

            //noinspection JSUnfilteredForInLoop
            let stationData = station.data[period];

            if (stationData.length < 1) {
                stationHtml.push("No data for this period");
                continue;
            }

            let hundredPct = stationData[0].data_value;

            let rows = stationData.map((stationData, i) => {
                let width = stationData.data_value / hundredPct * 100;

                return `<tr class="${i % 2 === 0 ? "even" : "odd"}">` +
                    `<td class="align_right">${stationData.rank}</td>` +
                    `<td><span class="proportion" style="width:${width}%"><p>${stationData.programme_name}</p></span></td>` +
                    `<td class="align_right">${parseFloat(stationData.data_value).toLocaleString()}</td>` +
                    "</tr>";
            }).join("\n");

            stationHtml.push(
                "<div class='section scroll_table_container'><table class='datagrid horizontal_charts'>" +
                "<thead><tr>" +
                "<th width='5%'></th>" +
                "<th width='65%'></th>" +
                `<th width='10%'>Thousands of viewers</th>` +
                `</tr></thead><tbody>${rows}</tbody></table></div>`);
        }

        return stationHtml.join("\n");
    }).join("\n");
};
